import { Button, Form, Input, Typography } from 'antd';
import React, { FC } from 'react';

import { messages, MessageTypes } from '../../../../pages/Auth/messages';
import { FormFooter, FormWrapper, StepContent } from '../styled';
import { BaseProps, DoctorType } from '../types';

interface DoctorFormType extends BaseProps<DoctorType> {
  loading: boolean;
}

const AuthForm: FC<DoctorFormType> = ({
  initialValues,
  onSubmit,
  loading,
  onBack,
}) => {
  const [profileForm] = Form.useForm();

  return (
    <StepContent>
      <Typography.Title level={3}>3. Update Doctor Profile</Typography.Title>
      <FormWrapper>
        <Form
          style={{ display: 'inline' }}
          form={profileForm}
          initialValues={initialValues}
          layout="vertical"
          onFinish={onSubmit}
        >
          <Form.Item
            label="Your specialization"
            hasFeedback
            name="specialization"
            rules={[
              { required: true, message: messages[MessageTypes.RequiredField] },
            ]}
          >
            <Input size="large" placeholder="Specialization" />
          </Form.Item>
          <Form.Item name="bio" hasFeedback label="Tell about yourself">
            <Input.TextArea size="large" placeholder="Your bio" rows={5} />
          </Form.Item>
          <FormFooter>
            <Button
              size="large"
              type="primary"
              onClick={onBack}
              style={{ marginRight: '10px' }}
            >
              Back
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Submit
            </Button>
          </FormFooter>
        </Form>
      </FormWrapper>
    </StepContent>
  );
};

export default AuthForm;
